export const positions = {
  TOP_LEFT: "top-left",
  TOP_CENTER: "top-center",
  TOP_RIGHT: "top-right",
  MIDDLE_LEFT: "middle-left",
  MIDDLE: "middle",
  MIDDLE_RIGHT: "middle-right",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_CENTER: "bottom-center",
  BOTTOM_RIGHT: "bottom-right",
  NONE: ""
};
export const arrowPositions = {
  TOP_LEFT: "top-left",
  TOP_CENTER: "top-center",
  TOP_RIGHT: "top-right",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_CENTER: "bottom-center",
  BOTTOM_RIGHT: "bottom-right",
  NONE: ""
};
export const types = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  DEFAULT: "default",
  NONE: ""
};
export const getTransaction = position => {
  switch (position) {
    case positions.TOP_LEFT:
    case positions.MIDDLE_LEFT:
    case positions.BOTTOM_LEFT:
      return {
        from: {
          transform: "translate3d(-110%,0,0)"
        },
        enter: {
          transform: "translate3d(0px,0,0)"
        },
        leave: {
          transform: "translate3d(-110%,0,0)"
        }
      };
    case positions.TOP_CENTER:
    case positions.MIDDLE:
    case positions.BOTTOM_CENTER:
      return {
        from: {
          opacity: 0,
          transform: "translate3d(-50%,-40px,0)"
        },
        enter: {
          opacity: 1,
          transform: "translate3d(-50%, 0px,0)"
        },
        leave: {
          opacity: 0,
          transform: "translate3d(-50%,-40px,0)"
        }
      };
    case positions.TOP_RIGHT:
    case positions.MIDDLE_RIGHT:
    case positions.BOTTOM_RIGHT:
    default:
      return {
        from: {
          transform: "translate3d(10%,0,0)"
        },
        enter: {
          transform: "translate3d(-100%,0,0)"
        },
        leave: {
          transform: "translate3d(10%,0,0)"
        }
      };
  }
};
export const groupBy = (array, fn) => array.reduce((result, item) => {
  const newResult = result;
  const key = fn(item);
  if (!newResult[key]) newResult[key] = [];
  newResult[key].push(item);
  return newResult;
}, {});
//# sourceMappingURL=options.js.map